<template>
  <div class="">
    <!-- <h3 class="text-xs-center">
      Tabla de Umbrales
    </h3> -->
    <v-toolbar
      color="light-green lighten-2"
      dark
      style="position: sticky; top: 0; z-index: 1; background-color:#81D4FA; padding-left:5%; margin-bottom:-8px;"
    >
      <v-toolbar-title
        center
        style="color: white !important; text-align: center !important;"
        class="justify-center"
      >
        <h4 class="text-xs-center">
          <v-icon class="icon">mdi-table-of-contents</v-icon>Tabla de Umbrales
        </h4>
      </v-toolbar-title>
    </v-toolbar>
    <br />
    <div class="threshold">
      <v-data-table
        :headers="headers"
        :items="threholds"
        :pagination.sync="pagination"
        class="elevation-1 report-table"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.alto }}</td>
          <td class="text-xs-center">{{ props.item.medio }}</td>
          <td class="text-xs-center">{{ props.item.bajo }}</td>
          <td class="text-xs-center">{{ props.item.protein }}</td>
          <td class="text-xs-center">{{ props.item.iron }}</td>
        </template>
      </v-data-table>
      <br />
      <div class="leyend">
        <strong>
          <p>
            * Por Planta
          </p>
          <p>
            ** Por Foliolo
          </p>
          <p>
            TRIPS - En estrato alto, trips por flor. En estratos medio y bajo,
            trips por estrato
          </p>
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "Plaga ",
          align: "left",
          sortable: false,
          value: "name",
        },
        { text: "Alto (A)", value: "alto", align: "center", sortable: false },
        { text: "Medio (M)", value: "medio", align: "center", sortable: false },
        { text: "Bajo (B)", value: "bajo", align: "center", sortable: false },
      ],
      threholds: [
        {
          name: "*Pulgón",
          alto: 1,
          medio: 3,
          bajo: 5,
        },
        {
          name: "*Mosca Blanca",
          alto: 3,
          medio: 5,
          bajo: 8,
        },
        {
          name: "**Araña Roja",
          alto: 3,
          medio: 5,
          bajo: 10,
        },
        {
          name: "Trips",
          alto: 3,
          medio: 2,
          bajo: 2,
        },
        {
          name: "*Lepidóptero",
          alto: 1,
          medio: 2,
          bajo: 2,
        },
        {
          name: "Mosca de Fruta",
          alto: 0,
          medio: 0,
          bajo: 0,
        },
        {
          name: "Roya",
          alto: 3,
          medio: 2,
          bajo: 1,
        },
        {
          name: "Botrytis",
          alto: 3,
          medio: 0,
          bajo: 0,
        },
      ],
      pagination: {
        // descending: false,
        // page: 1,
        rowsPerPage: 10,
        // totalItems: 0,
      },
    };
  },
};
</script>

<style scoped>
.threshold {
  padding: 50px !important;
}
</style>
